// Mock data para MB Chicken - Datos extraídos del menú real

const mockCities = [
    {
        id: 1,
        name: "MB Chicken Mérida",
        friendlyName: "Mérida",
        storeNumber: "7001",
        city: "Mérida",
        state: "Yucatán",
        address: "Plaza Altabrisa, Calle 7 #451, Col. Altabrisa",
        phone: "9991234567",
        lat: "20.9674",
        lon: "-89.5926",
        token: "mock-token-mb-chicken-merida",
        status: "open",
        schedule: "11:00 - 22:00"
    }
];

const mockCategories = [
    { idCat: 1, name: "Combos Sandwich", nameUrl: "combos-sandwich", subTitle: "Incluyen Taters chicas y refresco 600ml", image: "" },
    { idCat: 2, name: "Combos Piezas", nameUrl: "combos-piezas", subTitle: "Incluyen Taters chicas, complemento chico y refresco 600ml", image: "" },
    { idCat: 3, name: "Paquetes", nameUrl: "paquetes", subTitle: "Para compartir", image: "" },
    { idCat: 4, name: "Chicken Tenders", nameUrl: "chicken-tenders", subTitle: "Incluyen Taters chicas y refresco 600ml", image: "" },
    { idCat: 5, name: "Snacks", nameUrl: "snacks", subTitle: "Para picar", image: "" },
    { idCat: 6, name: "Ensalada", nameUrl: "ensalada", subTitle: "", image: "" },
    { idCat: 7, name: "Complementos", nameUrl: "complementos", subTitle: "Acompañamientos", image: "" },
];

// Imágenes de productos
const img = {
    bigMary: require('@/assets/images/products/mx/big-mary-combo.png'),
    spicyBigMary: require('@/assets/images/products/mx/spicy-big-mary-combo.png'),
    buffaloMary: require('@/assets/images/products/buffalo-mary.jpg'),
    sandwichParrilla: require('@/assets/images/products/grilled-chicken.jpg'),
    combo2pz: require('@/assets/images/products/mx/bm-combo.jpg'),
    combo3pz: require('@/assets/images/products/mx/chicken-taters.png'),
    combo4pz: require('@/assets/images/products/mx/fourpiece.png'),
    paquete9: require('@/assets/images/products/bucket-9pc.jpg'),
    paquete13: require('@/assets/images/products/bucket-13pc.jpg'),
    paquete18: require('@/assets/images/products/bucket-18pc.jpg'),
    paqueteTenders: require('@/assets/images/products/mx/five-tender-combo.jpg'),
    tenders3: require('@/assets/images/products/mx/three-tender-combo.jpg'),
    tenders5: require('@/assets/images/products/mx/five-tender-combo.jpg'),
    poutine: require('@/assets/images/products/tater-poutine.jpg'),
    popIns: require('@/assets/images/products/mx/pop-ins-masked.png'),
    miniMary: require('@/assets/images/products/mx/mini-mary.png'),
    chickenTwists: require('@/assets/images/products/chicken-twists.jpg'),
    ensalada: require('@/assets/images/products/mx/mac-salad.png'),
    taters: require('@/assets/images/products/mx/taters.png'),
    gravy: require('@/assets/images/products/mx/gravy.png'),
    coleslaw: require('@/assets/images/products/coleslaw.jpg'),
    mashedPotatoes: require('@/assets/images/products/mx/mashed-potatoes.jpg'),
    biscuit1: require('@/assets/images/products/biscuit.jpg'),
    biscuit6: require('@/assets/images/products/biscuit.jpg'),
    biscuit12: require('@/assets/images/products/biscuit.jpg'),
};

// Estructura para getHomeItems: array de objetos con idCat e item[]
const mockHomeItems = [
    {
        idCat: 1,
        item: [
            { idItem: 101, name: "Combo Big Mary", description: "Sandwich Big Mary con Taters chicas y refresco de 600 ml", price: 164, image: img.bigMary, catUrl: "combos-sandwich", idCat: 1 },
            { idItem: 102, name: "Combo Spicy Big Mary", description: "Sandwich Spicy Big Mary con Taters chicas y refresco de 600 ml", price: 164, image: img.spicyBigMary, catUrl: "combos-sandwich", idCat: 1 },
            { idItem: 103, name: "Combo Buffalo Mary", description: "Sandwich Buffalo Mary con Taters chicas y refresco de 600 ml", price: 174, image: img.buffaloMary, catUrl: "combos-sandwich", idCat: 1 },
            { idItem: 104, name: "Combo Sandwich Parrilla", description: "Sandwich de pollo a la parrilla con Taters chicas y refresco de 600 ml", price: 174, image: img.sandwichParrilla, catUrl: "combos-sandwich", idCat: 1 },
        ]
    },
    {
        idCat: 2,
        item: [
            { idItem: 201, name: "Combo 2 Piezas", description: "2 piezas de pollo con Taters chicas, complemento chico y refresco 600 ml", price: 149, image: img.combo2pz, catUrl: "combos-piezas", idCat: 2 },
            { idItem: 202, name: "Combo 3 Piezas", description: "3 piezas de pollo con Taters chicas, complemento chico y refresco 600 ml", price: 179, image: img.combo3pz, catUrl: "combos-piezas", idCat: 2 },
            { idItem: 203, name: "Combo 4 Piezas", description: "4 piezas de pollo con Taters chicas, complemento chico y refresco 600 ml", price: 199, image: img.combo4pz, catUrl: "combos-piezas", idCat: 2 },
        ]
    },
    {
        idCat: 3,
        item: [
            { idItem: 301, name: "Paquete 9 Piezas", description: "Para 4 personas: Taters grandes, complemento mediano y gravy mediano", price: 429, image: img.paquete9, catUrl: "paquetes", idCat: 3 },
            { idItem: 302, name: "Paquete 13 Piezas", description: "Para 6 personas: Taters grandes, complemento grande y gravy grande", price: 599, image: img.paquete13, catUrl: "paquetes", idCat: 3 },
            { idItem: 303, name: "Paquete 18 Piezas", description: "Para 9 personas: 2 Taters grandes, 2 complementos grandes y gravy grande", price: 849, image: img.paquete18, catUrl: "paquetes", idCat: 3 },
            { idItem: 304, name: "Paquete 10 Chicken Tenders", description: "Para 4 personas: Taters grandes, complemento mediano, gravy mediano y 3 Dips", price: 369, image: img.paqueteTenders, catUrl: "paquetes", idCat: 3 },
        ]
    },
    {
        idCat: 4,
        item: [
            { idItem: 401, name: "3 Tenders Combo", description: "3 Chicken Tenders con 1 Dip, Taters chicas y refresco 600 ml", price: 149, image: img.tenders3, catUrl: "chicken-tenders", idCat: 4 },
            { idItem: 402, name: "5 Tenders Combo", description: "5 Chicken Tenders con 2 Dips, Taters chicas y refresco 600 ml", price: 189, image: img.tenders5, catUrl: "chicken-tenders", idCat: 4 },
        ]
    },
    {
        idCat: 5,
        item: [
            { idItem: 501, name: "Tater Poutine", description: "Taters hechas a mano con delicioso gravy y queso derretido", price: 69, image: img.poutine, catUrl: "snacks", idCat: 5 },
            { idItem: 502, name: "Snack Pop-Ins", description: "Trozos de pechuga de pollo, empanizados, fritos y dorados", price: 59, image: img.popIns, catUrl: "snacks", idCat: 5 },
            { idItem: 503, name: "Mini Mary", description: "Con Mayonesa o Spicy Mayo", price: 59, image: img.miniMary, catUrl: "snacks", idCat: 5 },
            { idItem: 504, name: "2 Chicken Twists", description: "Taquitos fritos rellenos con pollo, queso y salsa Buffalo", price: 69, image: img.chickenTwists, catUrl: "snacks", idCat: 5 },
        ]
    },
    {
        idCat: 6,
        item: [
            { idItem: 601, name: "Ensalada de Pollo", description: "Lechugas, pepino, cebolla morada, tomate y mezcla de quesos. Aderezo Blue Cheese o vinagreta italiana", price: 139, image: img.ensalada, catUrl: "ensalada", idCat: 6 },
        ]
    },
    {
        idCat: 7,
        item: [
            { idItem: 701, name: "Taters Chico", description: "Taters hechas a mano - Tamaño chico", price: 39, image: img.taters, catUrl: "complementos", idCat: 7 },
            { idItem: 702, name: "Taters Mediano", description: "Taters hechas a mano - Tamaño mediano", price: 54, image: img.taters, catUrl: "complementos", idCat: 7 },
            { idItem: 703, name: "Taters Grande", description: "Taters hechas a mano - Tamaño grande", price: 79, image: img.taters, catUrl: "complementos", idCat: 7 },
            { idItem: 704, name: "Gravy Chico", description: "Salsa gravy - Tamaño chico", price: 24, image: img.gravy, catUrl: "complementos", idCat: 7 },
            { idItem: 705, name: "Gravy Mediano", description: "Salsa gravy - Tamaño mediano", price: 34, image: img.gravy, catUrl: "complementos", idCat: 7 },
            { idItem: 706, name: "Gravy Grande", description: "Salsa gravy - Tamaño grande", price: 44, image: img.gravy, catUrl: "complementos", idCat: 7 },
            { idItem: 707, name: "Ensalada de Col Chico", description: "Ensalada de col fresca - Chico", price: 39, image: img.coleslaw, catUrl: "complementos", idCat: 7 },
            { idItem: 708, name: "Ensalada de Col Mediano", description: "Ensalada de col fresca - Mediano", price: 54, image: img.coleslaw, catUrl: "complementos", idCat: 7 },
            { idItem: 709, name: "Ensalada de Col Grande", description: "Ensalada de col fresca - Grande", price: 79, image: img.coleslaw, catUrl: "complementos", idCat: 7 },
            { idItem: 710, name: "Puré de Papa Chico", description: "Puré de papa cremoso - Chico", price: 39, image: img.mashedPotatoes, catUrl: "complementos", idCat: 7 },
            { idItem: 711, name: "Puré de Papa Mediano", description: "Puré de papa cremoso - Mediano", price: 54, image: img.mashedPotatoes, catUrl: "complementos", idCat: 7 },
            { idItem: 712, name: "Puré de Papa Grande", description: "Puré de papa cremoso - Grande", price: 79, image: img.mashedPotatoes, catUrl: "complementos", idCat: 7 },
            { idItem: 713, name: "1 Bisquet", description: "Bisquet recién horneado", price: 22, image: img.biscuit1, catUrl: "complementos", idCat: 7 },
            { idItem: 714, name: "6 Bisquets", description: "6 bisquets recién horneados", price: 110, image: img.biscuit6, catUrl: "complementos", idCat: 7 },
            { idItem: 715, name: "12 Bisquets", description: "12 bisquets recién horneados", price: 210, image: img.biscuit12, catUrl: "complementos", idCat: 7 },
        ]
    },
];

export { mockCities, mockCategories, mockHomeItems };
